import { useState } from "react";

export function useProvideAuth() {  
  if(window.localStorage.getItem('eventsafeguardtoken'))
  {
    const user = {
      user: window.localStorage.getItem('user'),
      fullname: window.localStorage.getItem('fullname'),
      companyName: window.localStorage.getItem('companyname'),
      companyUniqueKey:window.localStorage.getItem('companyUniqueKey'),
      token: window.localStorage.getItem('eventsafeguardtoken')
    };
    return user;
  }
  else
    return { user:null }
}
